export enum CoreComputerVisionFaceAttribute {
	SELFIE_MODE = 'CoreComputerVisionFace-selfieMode',
	MAX_NUM_FACES = 'CoreComputerVisionFace-maxNumFaces',
	REFINE_LANDMARKS = 'CoreComputerVisionFace-refineLandmarks',
	MIN_DETECTION_CONFIDENCE = 'CoreComputerVisionFace-minDetectionConfidence',
	MAX_TRACKING_CONFIDENCE = 'CoreComputerVisionFace-minTrackingConfidence',
	KEY = 'CoreComputerVisionFace-key',
}
